import { AfterViewInit, Component, ElementRef, ViewChild, OnInit } from '@angular/core';
import gsap from 'gsap';

import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'fgb-fantasy-nav-v2',
  templateUrl: './fantasy-nav-v2.component.html',
  styleUrl: './fantasy-nav-v2.component.scss',
})
export class FantasyNavV2Component implements OnInit, AfterViewInit {
  @ViewChild('navContainer') navContainer!: ElementRef;
  @ViewChild('indicator') indicator!: ElementRef;

  constructor(private router: Router) {}

  ngOnInit() {
    this.router.events.pipe(filter((e) => e instanceof NavigationEnd)).subscribe(() => {
      requestAnimationFrame(() => {
        this.moveToActive();
      });
    });
  }

  ngAfterViewInit() {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.moveToActive();
      });
    });
  }

  moveToActive() {
    if (!this.navContainer || !this.indicator) return;

    const container = this.navContainer.nativeElement;
    const indicator = this.indicator.nativeElement;

    const active = container.querySelector('.nav-item.active');

    if (!active || active.offsetWidth === 0) {
      requestAnimationFrame(() => this.moveToActive());
      return;
    }

    const containerRect = container.getBoundingClientRect();
    const activeRect = active.getBoundingClientRect();

    const x = activeRect.left - containerRect.left;

    gsap.to(indicator, {
      x,
      width: activeRect.width,
      duration: 0.4,
      opacity: 1,
      ease: 'power3.out',
    });
  }
}
